const validMobileNumber = (mobileNumber: string) => {
  const regex = /^(?:\+1[-.\s]?)?(?:\(?\d{3}\)?[-.\s]?)?\d{3}[-.\s]?\d{4}$/;

  return {
    isValid: regex.test(mobileNumber),
    mobile: mobileNumber,
  };
};

export default validMobileNumber;
